import { Typography, Carousel, theme } from "kosmos-ui/lib";

import { useLayout } from "app/context/LayoutContext/hooks";
import { useCompanyCategories } from "app/context/CompanyCategoriesContext/hooks";
import PosterCard from "app/components/PosterCard";

import {
  CompanyCategoriesContainer,
  CompanyCategoryContainer,
  CompanyCategoryTagsContainer,
  CompanyCategoryTagChip,
  CompanyCategoryLink,
} from "./styles";
import RecommendationItemCard from "app/components/RecommendationItemCard";
import { ROUTES } from "app/constants/app";

export default function HomeCompanyCategories() {
  const { mobile } = useLayout();

  const { companyCategories, loadingCompanyCategoriesData } =
    useCompanyCategories();

  return (
    <CompanyCategoriesContainer>
      <CompanyCategoryContainer style={{ marginBottom: !mobile ? 72 : 32 }}>
        <PosterCard
          gradientFrom="#7038ff"
          gradientTo="#6ec3f4"
          style={{ height: "50vh", maxHeight: 440 }}
        >
          <Typography
            as="h1"
            variant="title1"
            style={{ opacity: 0.4, marginBottom: mobile ? 8 : 0 }}
          >
            Inspirados por tí.
          </Typography>

          <Typography as="h1" variant="title1">
            Creados para tí.
          </Typography>

          <Typography
            as="h2"
            variant="paragraph1"
            style={{
              color: theme.colorsPalette.white.default,
              maxWidth: 560,
              fontWeight: theme.fontWeights.bold,
              marginBottom: 8,
            }}
          >
            Marcas y productos 100% talento nacional. Conoce nuevos conceptos,
            ideas y productos de tu interés.
          </Typography>

          <Typography
            as="h2"
            variant="paragraph1"
            style={{
              color: theme.colorsPalette.white.default,
              maxWidth: 560,
              fontWeight: theme.fontWeights.bold,
              margin: 0,
            }}
          >
            Marcas independientes y categorías especiales de creadores en Chile.
          </Typography>
        </PosterCard>
      </CompanyCategoryContainer>

      {loadingCompanyCategoriesData ? (
        <p>Cargando categorías...</p>
      ) : (
        companyCategories?.map((companyCategory, index) => {
          const companies = companyCategory.companies;

          return (
            <CompanyCategoryContainer key={companyCategory._id}>
              <CompanyCategoryLink
                to={`${ROUTES.companyCategory}/${companyCategory._id}`}
              >
                {companyCategory.name}
              </CompanyCategoryLink>

              {companyCategory.description && (
                <Typography
                  as="h2"
                  variant="paragraph1"
                  style={{ marginTop: -8 }}
                >
                  {companyCategory.description}
                </Typography>
              )}

              {companyCategory.tags && (
                <CompanyCategoryTagsContainer>
                  {companyCategory.tags.map((tag, index) => (
                    <CompanyCategoryTagChip
                      type="secondary"
                      key={index}
                      style={{
                        backgroundColor: theme.colorsPalette.black.lighter,
                        color: theme.colorsPalette.gray.default,
                      }}
                    >
                      #{tag}
                    </CompanyCategoryTagChip>
                  ))}
                </CompanyCategoryTagsContainer>
              )}

              <Carousel
                withArrows
                slidesAtOnce={mobile ? 1 : 4}
                style={{
                  root: {
                    height: 216,
                    marginBottom:
                      index !== companyCategories.length - 1 ? 48 : 0,
                  },
                }}
              >
                {companies.map((company, index) => (
                  <Carousel.Slide key={index}>
                    <RecommendationItemCard
                      key={company._id}
                      render="poster"
                      item={{
                        _id: company._id,
                        color: company.color,
                        type: "company",
                        internalLink: `${ROUTES.company}/${company._id}`,
                        img: company.bgImg,
                        name: company.fantasyName,
                        description: company.description,
                      }}
                      style={{ root: { marginRight: !mobile ? 16 : 0 } }}
                    />
                  </Carousel.Slide>
                ))}
              </Carousel>
            </CompanyCategoryContainer>
          );
        })
      )}
    </CompanyCategoriesContainer>
  );
}
